import { PropsWithChildren, useState } from 'react';
import { Navbar } from './navbar';
import { Sidebar } from './sidebar';
import { Toaster } from '@/components/ui/toaster';

export function Shell({
  children,
  showSidebar = true,
}: PropsWithChildren<{ showSidebar?: boolean }>) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex min-h-dvh w-full flex-col bg-background text-foreground">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground focus:outline-none focus:ring-2 focus:ring-ring"
      >
        Skip to main content
      </a>
      <Navbar onMenuClick={() => setMobileMenuOpen(true)} showMenuButton={showSidebar} />
      <div
        className={
          showSidebar ? 'grid flex-1 grid-cols-1 md:grid-cols-[220px_1fr]' : 'flex flex-1 flex-col'
        }
      >
        {showSidebar && (
          <>
            <Sidebar />
            <Sidebar mobile open={mobileMenuOpen} onOpenChange={setMobileMenuOpen} />
          </>
        )}
        <main id="main-content" className="px-4 py-4 sm:px-6 sm:py-6">
          {children}
        </main>
      </div>
      <Toaster />
    </div>
  );
}
